__turbopack_context__.v({
  "activeItem": "SidebarHelp-module__p1baQW__activeItem",
  "categoryLabel": "SidebarHelp-module__p1baQW__categoryLabel",
  "fullWidth": "SidebarHelp-module__p1baQW__fullWidth",
  "helpLink": "SidebarHelp-module__p1baQW__helpLink",
  "helpPopover": "SidebarHelp-module__p1baQW__helpPopover",
  "helpPopoverContent": "SidebarHelp-module__p1baQW__helpPopoverContent",
  "helpSection": "SidebarHelp-module__p1baQW__helpSection",
});
